export default {
    TABLE_VIEW: "Просмотреть в таблице"
};
